/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkDecisionRequestBidirectionalActionDetailsDetails } from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetails';
import {
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSONTyped,
} from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetails';

/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequestBidirectionalActionDetails
 */
export interface InstanceBulkDecisionRequestBidirectionalActionDetails {
    /**
     * 
     */
    action: InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum;
    /**
     * 
     */
    details?: InstanceBulkDecisionRequestBidirectionalActionDetailsDetails;
}


/**
 * @export
 */
export const InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum = {
    Accept: 'Accept',
    Decline: 'Decline',
    RequestInformation: 'RequestInformation',
    ReferralReceived: 'ReferralReceived',
} as const;
export type InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum = typeof InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum[keyof typeof InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum];


/**
 * Check if a given object implements the InstanceBulkDecisionRequestBidirectionalActionDetails interface.
 */
export function instanceOfInstanceBulkDecisionRequestBidirectionalActionDetails(value: object): value is InstanceBulkDecisionRequestBidirectionalActionDetails {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetails {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequestBidirectionalActionDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'details': json['details'] == null ? undefined : InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json['details']),
    };
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsToJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetails {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsToJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsToJSONTyped(value?: InstanceBulkDecisionRequestBidirectionalActionDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'details': InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSON(value['details']),
    };
}

